module.exports = __webpack_public_path__ + "img/admin_service.b480f363.png";